import { forwardRef, useId, type SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { DIAL_CODES } from '@/features/auth/job-titles';

/**
 * Sélecteur d'indicatif, collé au champ numéro pour former un seul contrôle visuel.
 * Partagé par l'inscription et par Paramètres › Profil.
 *
 * Pas de libellé visible — la maquette n'en montre pas et le champ voisin porte déjà le
 * sens — mais un `aria-label` : sans lui, un lecteur d'écran annoncerait une liste
 * déroulante anonyme au milieu du formulaire.
 */
export const DialCodeSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function DialCodeSelect(props, ref) {
    const id = useId();

    return (
      <div className="relative flex shrink-0 items-center rounded-xl bg-white pr-5 pl-2.5 ring-1 ring-ink-100 transition focus-within:ring-2 focus-within:ring-ink-900">
        <select
          ref={ref}
          id={id}
          aria-label="Indicatif téléphonique"
          className="h-full cursor-pointer appearance-none bg-transparent text-sm text-ink-900 focus-visible:outline-none disabled:cursor-not-allowed"
          {...props}
        >
          {DIAL_CODES.map((dialCode) => (
            <option key={dialCode.code} value={dialCode.code}>
              {dialCode.code}
            </option>
          ))}
        </select>

        <ChevronDown aria-hidden className="pointer-events-none absolute right-2 size-3.5 text-ink-300" />
      </div>
    );
  },
);
